import { formFieldComponents } from '@/forms/components/FormListItemContainer';
import RequestLinksList from './components/RequestLinksList';
import RequestObjectsTable from './components/RequestObjectsTable';

export default {
  links: { editor: RequestLinksList, component: RequestLinksList, hasLabel: true },
  objects: { editor: RequestObjectsTable, component: RequestObjectsTable, hasLabel: true },
  ...formFieldComponents,
};
